
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticPaths, GetStaticProps } from 'next';
import AlternativePage from '@/components/agents/alternatives/AlternativePage';
import { alternativeSlugs, getAlternativeProps, } from '@/components/agents/alternatives/server';
import type { AlternativePageProps } from '@/components/agents/alternatives/types';
export default function AgentAlternative(props: AlternativePageProps) {
    return <AlternativePage {...props}/>;
}
// English only: other languages redirect to these paths (next.config.mjs).
export const getStaticPaths: GetStaticPaths = async () => ({
    paths: alternativeSlugs().map((slug) => ({ params: { slug }, locale: 'en' })),
    fallback: false,
});
const getStaticProps: GetStaticProps<AlternativePageProps> = async ({ params, locale, }) => {
    if (locale && locale !== 'en')
        return { notFound: true };
    const props = await getAlternativeProps(String(params?.slug ?? ''));
    if (!props)
        return { notFound: true };
    // Hourly, so a price change in Stripe reaches the page without a deploy.
    return { props, revalidate: 3600 };
};

    async function __Next_Translate__getStaticProps__1a15d8fc25b__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alternatives/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15d8fc25b__ as getStaticProps }
  